import styles from './Breakpoint.module.scss'
import { ReactComponent as CheckIcon } from './check.svg'
import { ReactComponent as PausedIcon } from './pause.svg'
import { ReactComponent as PlayingIcon } from './playing.svg'

const Breakpoint = ({ name, end, start, videoTime, seekTo, playing, pause }) => {
  const playTime = videoTime > start && videoTime < end

  if (!(start && end && name)) {
    return null
  }

  return (
    <div
      className={styles.breakpoint}
      onClick={() => (playTime ? pause() : seekTo(start))}
    >
      <div className={styles.icon}>
        {playTime && (playing ? <PlayingIcon /> : <PausedIcon />)}
        {videoTime > end && <CheckIcon />}
      </div>
      <div className={playTime ? styles.nameActive : styles.name}>{name}</div>
      <div className={styles.duration}>{Math.floor(end - start)}s</div>
    </div>
  )
}

export default Breakpoint
